import { RefundConfiguration } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import {
   AdvancePaymentsSettingsFormBean,
   WithFullRefund,
   WithoutAutomaticRefund,
   WithTimeBasedRefund,
} from './AdvancePaymentsSettingsForm.types';
import { FULL_REFUND_THRESHOLD_IN_HOURS_DEFAULT_VALUE } from './fields/FullRefundThresholdInHoursField';

type RefundTypeVisitor = <ACCEPT>(visitor: {
   visitFullRefund: (bean: WithFullRefund) => ACCEPT;
   visitTimeBasedRefund: (bean: WithTimeBasedRefund) => ACCEPT;
   visitWithoutAutomaticRefund: (bean: WithoutAutomaticRefund) => ACCEPT;
}) => ACCEPT | null;

export const refundTypeVisitor = (bean: AdvancePaymentsSettingsFormBean): RefundTypeVisitor => (visitor) => {
   if (!bean.automaticRefundEnabled) {
      return visitor.visitWithoutAutomaticRefund(bean);
   }

   if (bean.refundType === 'TIME_BASED_REFUND') {
      return visitor.visitTimeBasedRefund(bean);
   }

   if (bean.refundType === 'FULL_REFUND') {
      return visitor.visitFullRefund(bean);
   }

   return null;
};

export const formInitializer = (
   refundConfiguration: RefundConfiguration | null
) => (): AdvancePaymentsSettingsFormBean => {
   if (
      !refundConfiguration ||
      !refundConfiguration.configurationDetails ||
      refundConfiguration.automaticRefundEnabled === false
   ) {
      return { automaticRefundEnabled: false };
   }

   const { refundType, timeBasedRefundDetails } = refundConfiguration.configurationDetails;

   if (refundType === 'FULL_REFUND') {
      return {
         automaticRefundEnabled: true,
         refundType: 'FULL_REFUND',
         fullRefundThresholdInHours: timeBasedRefundDetails!.at(0)!.thresholdInHours,
      };
   }

   if (refundType === 'TIME_BASED_REFUND') {
      return {
         automaticRefundEnabled: true,
         refundType: 'TIME_BASED_REFUND',
         timeBasedRefund: timeBasedRefundDetails!,
      };
   }

   return {
      automaticRefundEnabled: true,
      refundType: 'FULL_REFUND',
      fullRefundThresholdInHours: FULL_REFUND_THRESHOLD_IN_HOURS_DEFAULT_VALUE,
   };
};
